import { useEffect, useRef, useState } from "react";

export function useInViewport(options) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  const rootMargin = options?.rootMargin ?? "0px";
  const threshold = options?.threshold ?? 0.25;

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { root: null, rootMargin, threshold }
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [rootMargin, threshold]);

  return { ref, inView };
}
